import React, { useState } from "react";
import "./Cancle_Reason_Modal.css";
import { Form, Modal } from "react-bootstrap";
import Successfull_Modal from "../Successfull_Modal/Successfull_Modal";

function Cancle_Reason_Modal({
  setReasonId,
  ReasonId,
  setSelectedReason,
  selectedReason,
  ...props
}) {
  const [modalShow, setModalShow] = useState(false);

  const handleReason = async (d) => {
    await props.setReason(d);
    props.onHide();
  };

  return (
    <>
      <div className="Reason_Modal">
        <Modal
          className=" Cancel_Reason_Modal"
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            {" "}
            Select a reason 
            {/* for {props.text} */}
          </Modal.Header>
          <Modal.Body>
            <div className="select_reason">
              <Form>
                {props?.reason?.map((value, index) => (
                  <Form.Check
                    key={index}
                    label={value?.name}
                    value={value?.id}
                    name="order_cancel_reason_id"
                    type="radio"
                    className="mini-text"
                    checked={ReasonId === value?.id}
                    onChange={(e) => {
                      setReasonId(Number(e.target.value));
                      setSelectedReason(value);

                      props.onHide();
                    }}
                  />
                ))}

                {/* 
                <Form.Check
                    label={val?.name}
                    name="name"
                    type="radio"
                    value="Product price has reduced"
                    onClick={() => handleReason("Product price has reduced")}
                    defaultChecked={
                      props.reason === "Product price has reduced"
                    }
                  /> */}
              </Form>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Cancle_Reason_Modal;
